import React, { useState, useRef, useEffect } from 'react';
import styles from './PromptsBar.module.scss';
import { ReactComponent as ArrowRight } from '../../assets/arrow_right_alt.svg';
import { ReactComponent as ArrowLeft } from '../../assets/arrow_left_alt.svg';

interface IPromptTemplateBar {
  onOptSelected: (opt: string) => void;
  style?: React.CSSProperties;
}

interface PromptNode {
  text: string;
  children?: PromptNode[];
}

const promptTree: PromptNode[] = [
  {
    text: "Who should I talk to?",
    children: [      
      { 
        text: "What are my top 5 declining accounts?",
        children: [
          { text: "What SKUs are declining for those accounts?" }
        ]
      },
      { 
        text: "What are my top 5 growing accounts?",
        children: [
          { text: "What SKUs are growing for those accounts?" },
          { text: "What SKUs are declining for those accounts?" }
        ]
      },
      { 
        text: "In what accounts are my Hero SKUs declining?",
        children: [
          { text: "What SKUs are growing for those accounts?" },          
        ]
      }
    ]
  },
  {
    text: "What should I sell?",
    children: [
      { 
        text: "What SKUs are declining?"        
      },
      { 
        text: "What SKUs are growing?",      
      }
    ]
  },
  {
    text: "What are my top business priorities?",
    children: [
      { text: "How am I doing so far this year in sales?" },
      //{ text: "How am I trending against my annual goal?" },
      { text: "In what accounts are my Hero SKUs declining?" }      
    ]
  },
  { text: "Show Hero SKU heatmap" },
  //{ text: "Show Hero SKU heatmap for Chicago" },
  //{ text: "Show my territory (preview for phase 2)" },
  { 
    text: "PowerBI",
    children: [
      { text: "Give me a list of customer's sales this year vs last year.  Show me in Power BI." },
      { text: "What Hero SKUs is practitioner purchasing? Show me in Power BI." },
      { text: "What Products Have My Accounts Abruptly Stopped Ordering? Show me in Power BI." },      
      { text: "Give me YOY sales growth for practitioner in Power BI." }
    ]
  },
];

const PromptsBar: React.FC<IPromptTemplateBar> = ({ onOptSelected, style }) => {
  const [navigationStack, setNavigationStack] = useState<PromptNode[][]>([promptTree]);
  const [isSubLevel, setIsSubLevel] = useState(false);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);
  const carouselRef = useRef<HTMLDivElement>(null);

  const checkForArrows = () => {
    if (carouselRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = carouselRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
    }
  };

  const handlePromptClick = (prompt: PromptNode) => {
    if (prompt.children) {
      setNavigationStack(prev => [...prev, prompt.children!]);
      setIsSubLevel(true);
    } else {
      // Reset to initial state if selected option has no children
      setNavigationStack([promptTree]);
      setIsSubLevel(false);
    }
    onOptSelected(prompt.text);
  };

  const scroll = (direction: 'left' | 'right') => {
    if (carouselRef.current) {
      const scrollAmount = 200;
      const newScrollLeft = direction === 'left' 
        ? carouselRef.current.scrollLeft - scrollAmount
        : carouselRef.current.scrollLeft + scrollAmount;
      
      carouselRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  const currentPrompts = navigationStack[navigationStack.length - 1];

  return (
    <div className={styles.carouselContainer}>
      {showLeftArrow && (
        <button 
          className={`${styles.scrollButton} ${styles.scrollButtonLeft}`}
          onClick={() => scroll('left')}
        >
          <ArrowLeft fill='#000000'/>
        </button>
      )}
      <div 
        ref={carouselRef}
        style={{ cursor: 'grab', userSelect: 'none' }}
        className={styles.carousel}
        onScroll={checkForArrows}
        onMouseDown={(e) => {
          const slider = e.currentTarget;
          let startX = e.pageX - slider.offsetLeft;
          let scrollLeft = slider.scrollLeft;

          const handleMouseMove = (e: MouseEvent) => {
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX);
            slider.scrollLeft = scrollLeft - walk;
          };

          const handleMouseUp = () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
          };

          document.addEventListener('mousemove', handleMouseMove);
          document.addEventListener('mouseup', handleMouseUp);
        }}
        onWheel={(e) => {
          // e.preventDefault();
          const slider = e.currentTarget;
          slider.scrollLeft += e.deltaY;
        }}
      >
        {currentPrompts.map((prompt) => (
          <div
            onClick={() => handlePromptClick(prompt)}
            className={isSubLevel? styles.item__sublevel : styles.item}
            key={prompt.text}
          >
            {prompt.text}
          </div>
        ))}
        {isSubLevel && promptTree.map((prompt) => (
          <div
            onClick={() => handlePromptClick(prompt)}
            className={styles.item}
            key={`root-${prompt.text}`}
          >
            {prompt.text}
          </div>
        ))}
      </div>
      {showRightArrow && (
        <button 
          className={`${styles.scrollButton} ${styles.scrollButtonRight}`}
          onClick={() => scroll('right')}
        >
          <ArrowRight fill='#000000'/>
        </button>
      )}
    </div>
  );
};

export default PromptsBar;